// Chapters Directory Page - Top Indian Cities

import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { 
  MapPin, 
  Users, 
  Calendar, 
  Phone, 
  Mail, 
  ExternalLink,
  Search,
  Filter,
  Star
} from 'lucide-react';
import Button from '../components/ui/Button';

interface Chapter {
  id: number;
  name: string;
  city: string;
  state: string;
  members: number;
  established: string;
  contact: {
    phone: string;
    email: string;
  };
  coordinator: string;
  status: 'active' | 'growing' | 'new';
  description: string;
  nextMeeting?: string;
}

const chapters: Chapter[] = [
  {
    id: 1,
    name: "Mumbai Central Chapter",
    city: "Mumbai",
    state: "Maharashtra",
    members: 0,
    established: "2023",
    contact: { phone: "+91 98765 43210", email: "mumbai@civicvoiceofindia.org" },
    coordinator: "Priya Sharma",
    status: "new",
    description: "Leading transparency initiatives in India's financial capital",
    nextMeeting: "2025-09-25"
  },
  {
    id: 2,
    name: "Delhi NCR Chapter",
    city: "New Delhi",
    state: "Delhi",
    members: 0,
    established: "2022",
    contact: { phone: "+91 98765 43211", email: "delhi@civicvoiceofindia.org" },
    coordinator: "Rajesh Kumar",
    status: "new",
    description: "Advocating for government accountability in the national capital",
    nextMeeting: "2025-09-22"
  },
  {
    id: 3,
    name: "Bengaluru Tech Chapter",
    city: "Bengaluru",
    state: "Karnataka",
    members: 0,
    established: "2023",
    contact: { phone: "+91 98765 43212", email: "bengaluru@civicvoiceofindia.org" },
    coordinator: "Anita Reddy",
    status: "new",
    description: "Digital governance and tech-enabled transparency solutions"
  },
  {
    id: 4,
    name: "Hyderabad Chapter",
    city: "Hyderabad",
    state: "Telangana",
    members: 0,
    established: "2023",
    contact: { phone: "+91 98765 43213", email: "hyderabad@civicvoiceofindia.org" },
    coordinator: "Srinivas Rao",
    status: "new",
    description: "Promoting civic awareness in the city of pearls"
  },
  {
    id: 5,
    name: "Chennai Chapter",
    city: "Chennai",
    state: "Tamil Nadu",
    members: 0,
    established: "2023",
    contact: { phone: "+91 98765 43214", email: "chennai@civicvoiceofindia.org" },
    coordinator: "Lakshmi Iyer",
    status: "new",
    description: "Cultural heritage preservation and government transparency"
  },
  {
    id: 6,
    name: "Kolkata Chapter",
    city: "Kolkata",
    state: "West Bengal",
    members: 0,
    established: "2024",
    contact: { phone: "+91 98765 43215", email: "kolkata@civicvoiceofindia.org" },
    coordinator: "Amit Ghosh",
    status: "new",
    description: "Intellectual discourse and civic engagement in the city of joy"
  },
  {
    id: 7,
    name: "Pune Chapter",
    city: "Pune",
    state: "Maharashtra",
    members: 0,
    established: "2024",
    contact: { phone: "+91 98765 43216", email: "pune@civicvoiceofindia.org" },
    coordinator: "Meera Joshi",
    status: "new",
    description: "Youth-driven transparency initiatives in the Oxford of the East"
  },
  {
    id: 8,
    name: "Ahmedabad Chapter",
    city: "Ahmedabad",
    state: "Gujarat",
    members: 0,
    established: "2024",
    contact: { phone: "+91 98765 43217", email: "ahmedabad@civicvoiceofindia.org" },
    coordinator: "Kiran Patel",
    status: "new",
    description: "Business community engagement for transparent governance"
  },
  {
    id: 9,
    name: "Jaipur Chapter",
    city: "Jaipur",
    state: "Rajasthan",
    members: 0,
    established: "2024",
    contact: { phone: "+91 98765 43218", email: "jaipur@civicvoiceofindia.org" },
    coordinator: "Sunita Singh",
    status: "new",
    description: "Heritage conservation and administrative transparency in Pink City"
  },
  {
    id: 10,
    name: "Lucknow Chapter",
    city: "Lucknow",
    state: "Uttar Pradesh",
    members: 0,
    established: "2024",
    contact: { phone: "+91 98765 43219", email: "lucknow@civicvoiceofindia.org" },
    coordinator: "Ashish Verma",
    status: "new",
    description: "Promoting civic awareness in the city of Nawabs"
  },
  {
    id: 11,
    name: "Kanpur Chapter",
    city: "Kanpur",
    state: "Uttar Pradesh",
    members: 0,
    established: "2024",
    contact: { phone: "+91 98765 43220", email: "kanpur@civicvoiceofindia.org" },
    coordinator: "Deepak Gupta",
    status: "new",
    description: "Industrial city transparency and environmental accountability"
  },
  {
    id: 12,
    name: "Nagpur Chapter",
    city: "Nagpur",
    state: "Maharashtra",
    members: 0,
    established: "2024",
    contact: { phone: "+91 98765 43221", email: "nagpur@civicvoiceofindia.org" },
    coordinator: "Ravi Deshmukh",
    status: "new",
    description: "Central India hub for governance transparency"
  },
  {
    id: 13,
    name: "Indore Chapter",
    city: "Indore",
    state: "Madhya Pradesh",
    members: 0,
    established: "2024",
    contact: { phone: "+91 98765 43222", email: "indore@civicvoiceofindia.org" },
    coordinator: "Neha Agarwal",
    status: "new",
    description: "Clean city initiatives and transparent municipal governance"
  },
  {
    id: 14,
    name: "Thane Chapter",
    city: "Thane",
    state: "Maharashtra",
    members: 0,
    established: "2024",
    contact: { phone: "+91 98765 43223", email: "thane@civicvoiceofindia.org" },
    coordinator: "Suresh Patil",
    status: "new",
    description: "Suburban governance and infrastructure transparency"
  },
  {
    id: 15,
    name: "Bhopal Chapter",
    city: "Bhopal",
    state: "Madhya Pradesh",
    members: 0,
    established: "2024",
    contact: { phone: "+91 98765 43224", email: "bhopal@civicvoiceofindia.org" },
    coordinator: "Kavita Sharma",
    status: "new",
    description: "State capital governance and policy transparency"
  },
  {
    id: 16,
    name: "Visakhapatnam Chapter",
    city: "Visakhapatnam",
    state: "Andhra Pradesh",
    members: 0,
    established: "2024",
    contact: { phone: "+91 98765 43225", email: "visakhapatnam@civicvoiceofindia.org" },
    coordinator: "Venkat Rao",
    status: "new",
    description: "Port city development and environmental transparency"
  },
  {
    id: 17,
    name: "Pimpri-Chinchwad Chapter",
    city: "Pimpri-Chinchwad",
    state: "Maharashtra",
    members: 0,
    established: "2024",
    contact: { phone: "+91 98765 43226", email: "pimpri@civicvoiceofindia.org" },
    coordinator: "Pooja Kulkarni",
    status: "new",
    description: "Industrial township governance and worker rights transparency"
  },
  {
    id: 18,
    name: "Patna Chapter",
    city: "Patna",
    state: "Bihar",
    members: 0,
    established: "2024",
    contact: { phone: "+91 98765 43227", email: "patna@civicvoiceofindia.org" },
    coordinator: "Manoj Singh",
    status: "new",
    description: "Ancient capital modern governance and educational transparency"
  },
  {
    id: 19,
    name: "Vadodara Chapter",
    city: "Vadodara",
    state: "Gujarat",
    members: 0,
    established: "2024",
    contact: { phone: "+91 98765 43228", email: "vadodara@civicvoiceofindia.org" },
    coordinator: "Nisha Shah",
    status: "new",
    description: "Cultural city development and heritage preservation transparency"
  },
  {
    id: 20,
    name: "Ghaziabad Chapter",
    city: "Ghaziabad",
    state: "Uttar Pradesh",
    members: 0,
    established: "2024",
    contact: { phone: "+91 98765 43229", email: "ghaziabad@civicvoiceofindia.org" },
    coordinator: "Rohit Agarwal",
    status: "new",
    description: "NCR development and urban planning transparency"
  }
];

const ChaptersPage: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState<'all' | 'active' | 'growing' | 'new'>('all');

  const filteredChapters = chapters.filter(chapter => {
    const matchesSearch = chapter.city.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         chapter.state.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         chapter.coordinator.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = filterStatus === 'all' || chapter.status === filterStatus;
    return matchesSearch && matchesFilter;
  });

  const getStatusBadge = (status: string) => {
    const badges = {
      active: 'bg-green-100 text-green-800 border-green-200',
      growing: 'bg-blue-100 text-blue-800 border-blue-200',
      new: 'bg-orange-100 text-orange-800 border-orange-200'
    };
    return badges[status as keyof typeof badges] || badges.new;
  };

  const getStatusIcon = (status: string) => {
    switch(status) {
      case 'active': return <Star className="w-3 h-3" />;
      case 'growing': return <Users className="w-3 h-3" />;
      case 'new': return <Calendar className="w-3 h-3" />;
      default: return <MapPin className="w-3 h-3" />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container-width section-padding">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-gradient-flag">Chapters</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Join a local chapter in your city and be part of the transparency movement. 
            Connect with like-minded citizens working for accountable governance.
          </p>

          {/* Search and Filter */}
          <div className="flex flex-col sm:flex-row gap-4 max-w-2xl mx-auto mb-8">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Search by city, state, or coordinator..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              />
            </div>
            <div className="relative">
              <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value as any)}
                className="pl-10 pr-8 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent appearance-none bg-white"
              >
                <option value="all">All Chapters</option>
                <option value="active">Active</option>
                <option value="growing">Growing</option>
                <option value="new">New</option>
              </select>
            </div>
          </div>
        </motion.div>

        {/* Chapters Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {filteredChapters.map((chapter, index) => (
            <motion.div
              key={chapter.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow duration-200"
            >
              {/* Chapter Header */}
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-gray-900 mb-1">
                    {chapter.name}
                  </h3>
                  <div className="flex items-center text-gray-600 mb-2">
                    <MapPin className="w-4 h-4 mr-1" />
                    <span className="text-sm">{chapter.city}, {chapter.state}</span>
                  </div>
                </div>
                <div className={`flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-medium border ${getStatusBadge(chapter.status)}`}>
                  {getStatusIcon(chapter.status)}
                  <span className="capitalize">{chapter.status}</span>
                </div>
              </div>

              {/* Chapter Stats */}
              <div className="grid grid-cols-2 gap-4 mb-4">
                <div className="text-center p-3 bg-gray-50 rounded-lg">
                  <div className="text-lg font-bold text-primary-600">{chapter.members}</div>
                  <div className="text-xs text-gray-600">Members</div>
                </div>
                <div className="text-center p-3 bg-gray-50 rounded-lg">
                  <div className="text-lg font-bold text-primary-600">{chapter.established}</div>
                  <div className="text-xs text-gray-600">Est.</div>
                </div>
              </div>

              {/* Description */}
              <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                {chapter.description}
              </p>

              {/* Coordinator */}
              <div className="mb-4">
                <div className="text-xs text-gray-500 mb-1">Chapter Coordinator</div>
                <div className="text-sm font-medium text-gray-900">{chapter.coordinator}</div>
              </div>

              {/* Next Meeting */}
              {chapter.nextMeeting && (
                <div className="mb-4 p-2 bg-blue-50 rounded-lg">
                  <div className="flex items-center text-blue-700">
                    <Calendar className="w-4 h-4 mr-2" />
                    <span className="text-xs">Next Meeting: {new Date(chapter.nextMeeting).toLocaleDateString()}</span>
                  </div>
                </div>
              )}

              {/* Contact Actions */}
              <div className="flex gap-2">
                <Button
                  size="sm"
                  variant="outline"
                  className="flex-1 text-xs"
                  onClick={() => window.location.href = `tel:${chapter.contact.phone}`}
                >
                  <Phone className="w-3 h-3 mr-1" />
                  Call
                </Button>
                <Button
                  size="sm"
                  variant="outline"
                  className="flex-1 text-xs"
                  onClick={() => window.location.href = `mailto:${chapter.contact.email}`}
                >
                  <Mail className="w-3 h-3 mr-1" />
                  Email
                </Button>
                <Button
                  size="sm"
                  variant="primary"
                  className="flex-1 text-xs"
                >
                  <ExternalLink className="w-3 h-3 mr-1" />
                  Join
                </Button>
              </div>
            </motion.div>
          ))}
        </div>

        {/* No Results */}
        {filteredChapters.length === 0 && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-center py-12"
          >
            <MapPin className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-600 mb-2">No chapters found</h3>
            <p className="text-gray-500 mb-6">Try adjusting your search or filter criteria</p>
            <Button variant="primary">
              Start a New Chapter
            </Button>
          </motion.div>
        )}

        {/* Call to Action */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center bg-gradient-to-r from-primary-50 to-secondary-50 rounded-2xl p-8 border border-primary-100"
        >
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Don't see your city?
          </h2>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            Be a pioneer in your community! Start a new chapter and lead the transparency 
            movement in your city. We'll provide all the support and resources you need.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" variant="primary">
              Start a New Chapter
            </Button>
            <Button size="lg" variant="outline">
              Learn More
            </Button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ChaptersPage;